import React from "react";

/**
 * Brand logo. Renders both the white and blue variant; visibility is controlled
 * via the `variant` prop or, when omitted, automatically by the parent's
 * background through the .ea-logo-auto helpers in index.css.
 */
export default function Logo({
  variant = "auto",
  className = "",
  height = 28,
  testId = "brand-logo",
}) {
  const blue = "/brand/envisio-logo-blue.png";
  const white = "/brand/envisio-logo-white.png";

  if (variant === "blue") {
    return (
      <img
        src={blue}
        alt="Envisio Advisory"
        height={height}
        style={{ height }}
        className={`w-auto select-none ${className}`}
        data-testid={testId}
        draggable={false}
      />
    );
  }
  if (variant === "white") {
    return (
      <img
        src={white}
        alt="Envisio Advisory"
        height={height}
        style={{ height }}
        className={`w-auto select-none ${className}`}
        data-testid={testId}
        draggable={false}
      />
    );
  }

  // auto: stack both, parent controls which one is visible via CSS
  return (
    <span
      className={`relative inline-block ${className}`}
      style={{ height }}
      data-testid={testId}
    >
      <img
        src={white}
        alt="Envisio Advisory"
        style={{ height }}
        className="ea-logo-on-dark w-auto select-none block"
        draggable={false}
      />
      <img
        src={blue}
        alt=""
        aria-hidden
        style={{ height }}
        className="ea-logo-on-light w-auto select-none block absolute inset-0"
        draggable={false}
      />
    </span>
  );
}
